// import Vue from 'vue/dist/vue.js'     // dev mode
//import 'babel-polyfill'
import Vue from 'vue/dist/vue.common.js'
import VueResource from 'vue-resource'
import Vue2Leaflet from 'vue2-leaflet';
import vmodal from 'vue-js-modal'

import GetCoordinate from './components/map.vue';
import GetPower from './components/power.vue';
import GetAutoConsumption from './components/autoconsumption.vue';
import GetElectricityPrice from './components/electricity_price.vue';
import GetInvestment from './components/investment.vue';
import ShowResults from './components/show_results.vue';
import Logo from './components/logo.vue';

import _ from 'lodash'

Vue.use(vmodal)
Vue.use(VueResource);

Vue.config.devtools = true;
// Vue.config.productionTip = false;
Vue.config.productionTip = true;


// Switch logo according to domain
var app_logo = new Vue(
    {
        el: '#app_logo',
        store,
        data: {
            name: 'logo',
        },
        render: (h) => h(
            Logo,
            {
                ref: 'logo',
            }
        ),
    }
);



import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'
Vue.use(Vuex)

// import store from './store';

////// STORE /////////////////////////////////////////

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    // forms
    form_power_ok: true,
    form_electricity_price_ok: true,
    form_investment_ok: true,
    
    // map
    latitude: 45.7682549,
    longitude: 4.85963219999996,
    
    // installation
    tilt: 30,
    tilt_old: 30,
    orientation: 0,
    orientation_old: 0,
    power: 9,
    power_old: 9,
    productivity: 1000,
    subscription: 9,

    autoconsumption: 30,

    // electricity prices
    current_price: 0,
    price_inflation_percent_for_5_years: 0,
    price_inflation_percent_after_5_years: 0,

    // investment
    investment_pv_installation: null,
    investment_pv_installation_old: null,
    // investment_iwb: null,
    investment_overlay: null,
    investment_surplus_sale: null,
    investment_free_sale: null,
    investment_autoconsumption: null,

}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    updateField,

    setLatitude (state, latitude) {
        state.latitude = parseFloat(latitude);
    },
    setLongitude (state, longitude) {
        state.longitude = parseFloat(longitude);
    },
    setPosition (state, position) {
        state.latitude = parseFloat(position.latitude);
        state.longitude = parseFloat(position.longitude);
    },
    setFormPowerOk (state, valid) {
        state.form_power_ok = valid;
    },
    setFormElectricityPriceOk (state, valid) {
        state.form_electricity_price_ok = valid;
    },
    setFormInvestmentOk (state, valid) {
        state.form_investment_ok = valid;
    },
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    // setPosition ({ commit }, position) {
    //     commit('setLatitude', position.latitude);
    //     commit('setLongitude', position.longitude);
    // },
}

// getters are functions
const getters = {
    getField,
    getLatitude: state => state.latitude,
    getLongitude: state => state.longitude,
    getPosition: state => { return { 'latitude': state.latitude, 'longitude': state.longitude }; },
}


const store =  new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})


////// /STORE /////////////////////////////////////////


// using jQuery
function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

var csrftoken = getCookie('csrftoken');
//Vue.http.headers.common['X-CSRFTOKEN'] = csrftoken;




    // Working map
    const app_map = new Vue(
        {
            el: '#app_map',
            store,
            data: {
                name: 'mmp',
                // bus: bus,
            },
            render: (h) => h(
                GetCoordinate,
                {
                    ref: 'map',
                    props: {
                        // bus: bus,
                        initial_latitude: 45.7682549,
                        initial_longitude: 4.85963219999996,
                    }
                }
            ),
        }
    );

    // Instalation capacity
    var app_power = new Vue(
        {
            el: '#app_power',
            store,
            data: {
                name: 'power',
            },
            render: (h) => h(
                GetPower,
                {
                    ref: 'power',
                }
            ),
        }
    );


    // Autoconsumption slider
    var app_autoconsumption = new Vue(
        {
            el: '#app_autoconsumption',
            store,
            data: {
                name: 'autoconsumption',
                value: 30,
            },
            render: (h) => h(
                GetAutoConsumption,
                {
                    ref: 'autoconsumption',
                    props: {
                        options: {
                            min: 0,
                            max: 100,
                            //interval: 5,
                            lazy: true,
                            tooltip: "always",
                            //piecewise: true,
                        },
                        value: 30,
                    }
                }
            ),
        }
    );


    // Instalation capacity
    var app_electricity_price = new Vue(
        {
            el: '#app_electricity_price',
            store,
            data: {
                name: 'electricity_price',
            },
            render: (h) => h(
                GetElectricityPrice,
                {
                    ref: 'electricity_price',
                }
            ),
        }
    );



    // Investment
    var app_investment = new Vue(
        {
            el: '#app_investment',
            store,
            data: {
                name: 'investment',
            },
            render: (h) => h(
                GetInvestment,
                {
                    ref: 'investment',
                }
            ),
        }
    );


    // Results
    var app_results = new Vue(
        {
            el: '#app_results',
            store,
            render: (h) => h(
                ShowResults,
                {
                    ref: 'app_results',
                }
            ),
        }
    );
    



// WEBPACK FOOTER //
// ./src/main.js